import _ from 'lodash'
import { getActive } from './active-items-util'

export function getDepartments (menuBlob) {
  return _.get(menuBlob, 'departments', [])
}

export function getActiveDepartments (menuBlob) {
  return getDepartments(menuBlob).filter(it => it.info.status === 'ACTIVE')
}

export function getDepartment (id, menuBlob) {
  return getDepartments(menuBlob).find(it => it.id === id)
}

export function getDepartmentBasicInfo (id, menuBlob) {
  const department = getDepartment(id, menuBlob)
  return {
    id: department.id,
    $added: department.$added,
    name: department.info.name,
    categories: department.categories.map(it => ({ id: it.id, name: it.info.name })),
    items: department.items.map(it => ({ id: it.id, name: it.info.name, category: it.category }))
  }
}

export function getAvailableItemHierarchy (menuBlob, includeInactive = false) {
  const departments = includeInactive ? getDepartments(menuBlob) : getActiveDepartments(menuBlob)

  const availableItems = []
  for (let department of departments) {
    const depEntry = departmentHierarchyEntry(department)

    const departmentItems = includeInactive ? _.values(department.items) : getActive(_.values(department.items))
    const departmentCategories = includeInactive ? _.values(department.categories) : getActive(_.values(department.categories))

    for (let category of departmentCategories) {
      const categoryItems = departmentItems.filter(next => next.category === category.id)
      depEntry.categories.push(categoryHierarchyEntry(category, categoryItems))
    }
    availableItems.push(depEntry)
  }
  return availableItems
}

export function buildHierarchyFromExistingItems (items, menuBlob) {
  const hierarchy = []
  for (let item of items) {
    const department = getDepartment(item.departmentId, menuBlob)

    const depEntry = departmentHierarchyEntry(department)

    const departmentItems = _.values(department.items)
    const departmentCategories = _.values(department.categories)

    for (let category of departmentCategories) {
      const categoryItems = departmentItems.filter(next => next.category === category.id)
      depEntry.categories.push(categoryHierarchyEntry(category, categoryItems))
    }

    const hierarchyItem = departmentItems.filter(i => i.category === item.categoryId).find(i => i.id === item.itemId)

    hierarchy.push({
      id: hierarchyItem.id,
      name: hierarchyItem.info.name,
      displayName: hierarchyItem.info.displayName,
      info: hierarchyItem.info,
      styles: hierarchyItem.styles,
      department: depEntry,
      category: depEntry.categories.find(cat => cat.id === item.categoryId)
    })
  }
  return hierarchy
}

export function departmentHierarchyEntry (department) {
  return {
    id: department.id,
    name: department.info.name,
    displayName: department.info.displayName,
    categories: [],
    imageId: department.info.imageId,
    info: department.info,
    styles: department.styles,
    $added: department.$added
  }
}

export function categoryHierarchyEntry (category, categoryItems) {
  return {
    id: category.id,
    name: category.info.name,
    displayName: category.info.displayName,
    imageId: category.info.imageId,
    info: category.info,
    styles: category.styles,
    $added: category.$added,
    items: categoryItems.map(item => {
      return {
        id: item.id,
        name: item.info.name,
        displayName: item.info.displayName,
        imageId: item.info.imageId,
        info: item.info,
        $added: item.$added
      }
    })
  }
}
